import BaseFontCss from './BaseFontCss';
export default BaseFontCss;